'use-strict';

const { asArray, isset, findByAddress } = require('@hints/utils/data');
const Protocol = require('./protocol');
const hrv = require('../utils/hrv');
const { normalize0100, average, weightedAverage } = require('../utils/math');
const pop = require('./population-stats');
const config = require('../data/energetical-config.json');
const { clamp } = require('@hints/utils/math');

class EnergeticalProtocol extends Protocol {
    getScore(evaluation, gender, age, ppi) {
        const heartrate = this.computeMeanHR(ppi);
        const { rmssd, rmssdScore } = this.computeRmssdScore(gender, age, ppi);
        const { wellnessScore, recoveryScore, fatigueScore } = this.extractPhysicalScores(evaluation);
        const score = weightedAverage(
            [wellnessScore, recoveryScore, fatigueScore, rmssdScore],
            [config.wellnessCoeff, config.recoveryCoeff, config.fatigueCoeff, config.hrvCoeff]
        );

        return {
            logs: ppi,
            data: {
                score: score,
                wellnessScore,
                recoveryScore,
                fatigueScore,
                rmssdScore,
                result: {
                    rmssd,
                    heartrate,
                }
            }
        };
    }

    validateResults(body) {
        if (!super.validateResults(body)) return false;
        const { result } = body;
        if (!isset(result)) return false;
        if (!isset(result.rmssd)) return false;
        if (!isset(result.heartrate)) return false;
        return true;
    }

    computeMeanHR(ppi) {
        const validHR = ppi.map(ppi => ppi.ppiHr).filter(hr => hr > 0);
        return average(validHR);
    }

    computeRmssdScore(gender, age, ppi) {
        const { mean, sd } = pop.energeticalRMSSD.getData(gender, age);
        const rrIntervals = asArray(ppi).map(ppi => ppi.ppi / 1000);
        const rrIntervalsFiltered = hrv.rrFilter(rrIntervals);
        const rmssd = (hrv.rmssd(rrIntervalsFiltered) || 0.001) * 1000;
        const lnRMSSD = Math.log(rmssd);
        const score = normalize0100((lnRMSSD - mean) / sd, -3, 3);
        const rmssdScore = clamp(score, config.minRMSSDScore, config.maxRMSSDScore);

        return { rmssdScore, rmssd };
    }

    extractPhysicalScores(evaluation) {
        return { 
            wellnessScore: findByAddress(evaluation, 'evalPhysical.wellnessScore') || 0,
            recoveryScore: findByAddress(evaluation, 'evalPhysical.recoveryScore') || 0,
            fatigueScore: findByAddress(evaluation, 'evalPhysical.fatigueScore') || 0,
        };
    }
}

module.exports = new EnergeticalProtocol();